/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 払込詳細<br/> 以下を全て満たす場合に、返却する。<br/> 1 FPエレメントのFOPコードがWBCASHまたはWCCASHである<br/> 2 払込期限が存在する
 */
export interface GetOrderResponseDataNextActionsOfflinePaymentDetails {
  /**
   * 払込期限(yyyy-MM-dd\'T\'HH:mm:ss形式)<br/> 以下に従って返却する。<br/> 1.支払方法がインターネットバンキング(bank)の場合<br/>   data.paymentRecords.paymentTransaction.paymentMethodのparametersの4番目に返却される購入期限(yyyyMMddHHmm形式)を操作オフィスのタイムゾーンに変換する<br/> 2.上記以外の場合<br/>   data.paymentRecords.paymentTransaction.paymentMethodのparametersの3番目に返却される購入期限(yyyyMMddHHmm形式)を操作オフィスのタイムゾーンに変換する<br/> ※購入期限は、DxAPIからyyyyMMddHHmm形式で返却されるため、秒(ss)の部分を\"00\"で補完後、「yyyy-MM-dd\'T\'HH:mm:ss」に変換して、返却する。
   */
  deadline?: string;
  /**
   * 払込期限を超過しているか<br/> 払込期限と現在時刻を比較し、現在時刻の方が後である場合true
   */
  isExpired?: boolean;
  /**
   * 支払方法<br/> convinienceStore：コンビニ支払<br/>   FPエレメントのFOPコード(DxAPIからはidとして返却されるコード)がWCCASHである、かつFOP末尾に\"PAYEASY\"が存在しない。<br/> bank：インターネットバンキング<br/>   FPエレメントのFOPコード(DxAPIからはidとして返却されるコード)がWBCASHである。<br/> payeasy：Pay-easy<br/>   FPエレメントのFOPコード(DxAPIからはidとして返却されるコード)がWCCASHである、かつFOP末尾に\"PAYEASY\"が存在する。
   */
  paymentMethod?: GetOrderResponseDataNextActionsOfflinePaymentDetails.PaymentMethodEnum;
  /**
   * 銀行コード<br/> ※ FPのフリーテキストの内容をDxAPIが文字列解析したものが返却され、支払方法がインターネットバンキングの場合解析されたパラメータの2番目に銀行コードが返却されるため、その内容を返却する。
   */
  bankCode?: string;
  /**
   * 決済番号<br/> 以下に従って返却する。<br/> 1.支払方法がインターネットバンキング(bank)の場合<br/>   FPのフリーテキストの内容をDxAPIが文字列解析したものが返却され、解析されたパラメータの3番目に決済番号が返却されるため、その内容を返却する。<br/> 2. 上記以外の場合<br/>   FPのフリーテキストの内容をDxAPIが文字列解析したものが返却され、解析されたパラメータの2番目に決済番号が返却されるため、その内容を返却する。
   */
  paymentNumber?: string;
  /**
   * 暗号化済み決済番号<br/> ※画面には暗号化されていない番号を表示するが、ウェルネットに送信する際には暗号化済みのものを使用するため、リクエストパラメータのマスキング要否がfalseの場合でも値を返却する。
   */
  encryptedPaymentNumber?: string;
}
export namespace GetOrderResponseDataNextActionsOfflinePaymentDetails {
  export type PaymentMethodEnum = 'convinienceStore' | 'bank' | 'payeasy';
  export const PaymentMethodEnum = {
    ConvinienceStore: 'convinienceStore' as PaymentMethodEnum,
    Bank: 'bank' as PaymentMethodEnum,
    Payeasy: 'payeasy' as PaymentMethodEnum,
  };
}
